"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainLanguage = exports.supportedLanguages = exports.getCountryByLanguageCode = exports.getCountryByCode = exports.Countries = exports.Domains = exports.DefaultSite = exports.defaultLanguageCode = void 0;
var typeUtils_1 = require("../typeUtils");
exports.defaultLanguageCode = 'en';
exports.DefaultSite = 'mitforlob.dk';
exports.Domains = [
    { sites: [exports.DefaultSite], language: 'da' },
    { sites: ['meinebehandlung.com', 'meinebehandlung.ch'], language: 'de' },
    { sites: ['mitratamiento.es'], language: 'es' },
    { sites: ['minbehandling.se'], language: 'sv' },
    { sites: ['minbehandling.com'], language: 'no' },
    { sites: ['meutratamento.org'], language: 'pt' },
    { sites: ['mytreatmentapp.com'], language: 'en' },
];
exports.Countries = [
    { name: 'Denmark', code: 'DK', language: 'danish', languageCode: 'da' },
    { name: 'Germany', code: 'DE', language: 'german', languageCode: 'de' },
    { name: 'Switzerland', code: 'CH', language: 'german', languageCode: 'de' },
    { name: 'England', code: 'GB', language: 'english', languageCode: 'en' },
    { name: 'Spain', code: 'ES', language: 'spanish', languageCode: 'es' },
    { name: 'France', code: 'FR', language: 'french', languageCode: 'fr' },
    { name: 'Switzerland', code: 'CH', language: 'french', languageCode: 'fr' },
    { name: 'Norway', code: 'NO', language: 'norwegian', languageCode: 'no' },
    { name: 'Brazil', code: 'BR', language: 'portuguese', languageCode: 'pt' },
    // { name: 'Portugal', code: 'PT', language: 'portuguese', languageCode: 'pt' },
    { name: 'Sweden', code: 'SE', language: 'swedish', languageCode: 'sv' },
];
function getCountryByCode(countryCode) {
    var country = exports.Countries.find(function (c) { return c.code === countryCode; });
    return country || exports.Countries[0];
}
exports.getCountryByCode = getCountryByCode;
function getCountryByLanguageCode(languageCode) {
    var country = exports.Countries.find(function (c) { return c.languageCode === languageCode; });
    return country || exports.Countries[0];
}
exports.getCountryByLanguageCode = getCountryByLanguageCode;
var supportedLanguages = function () { return exports.Countries.map(function (c) { return c.languageCode; }).filter(typeUtils_1.unique); };
exports.supportedLanguages = supportedLanguages;
function getDomainLanguage(host) {
    var _a;
    return ((_a = exports.Domains.find(function (domain) { return domain.sites.includes(host); })) === null || _a === void 0 ? void 0 : _a.language) || 'da';
}
exports.getDomainLanguage = getDomainLanguage;
//# sourceMappingURL=languages.js.map